import styled from 'styled-components';

export const PercentsFormDataWrapper = styled.div`
	display: flex;
	margin-bottom: 40px;
`;
